import React from "react";
import { Outlet } from "react-router";
import type { MeUserDataType } from "src/app";
import { Header } from "src/components/header";
import { LeftNavigation } from "src/components/left-navigation";
import { RequireScope } from "src/components/RequireScope";
import { PageSuspense } from "src/components/ui/page-suspense";
import { Toaster } from "src/components/ui/toaster";
import { NavigationProvider, useNavigation } from "src/context/NavigationContext";

function SkillsPageComponent() {
  return (
    <RequireScope scope="read:skills">
      <div className="h-full w-full">
        <PageSuspense>
          <Outlet />
        </PageSuspense>
      </div>
    </RequireScope>
  );
}

function SkillsPageLayoutContent({ page, me }: { page: React.ReactElement; me: MeUserDataType }) {
  const { isLeftNavCollapsed } = useNavigation();

  return (
    <div className="h-screen flex bg-background overflow-hidden">
      <LeftNavigation isCollapsed={isLeftNavCollapsed} />
      <div className="flex flex-col flex-1 h-screen">
        <Header me={me} />
        <main className="flex-1 flex flex-col h-full relative max-h-full overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br dark:from-slate-900/5 dark:to-slate-950/10 pointer-events-none" />
          {page}
        </main>
      </div>
      <Toaster />
    </div>
  );
}

export const getSkillsPageLayout = (page: React.ReactElement, me: MeUserDataType) => {
  return (
    <NavigationProvider>
      <SkillsPageLayoutContent page={page} me={me} />
    </NavigationProvider>
  );
};

const SkillsPage = Object.assign(SkillsPageComponent, {
  getLayout: getSkillsPageLayout,
});

export default SkillsPage;
